// How the chat SDK's own parts draw an agent's face (assistant-sdk chat/faceSlot.tsx: the question card, the sidebar's "Thinking…"): the
// face in the person's style, or nothing in the Icon style (the SDK keeps its glyph). `agent` is whose conversation it is when the SDK
// does not say: ECONIC in the shell, the agent itself on its page or in a conversation with it. WP-THEME (23 Oct 2026).
import { useCallback, type ReactNode } from "react";
import { AgentFaceContext, type RenderAgentFace } from "@ncp/assistant-sdk";
import { useFaceStyle } from "../theme/primitives";
import { LazyAgentFace } from "./LazyAgentFace";

export function AgentFaceProvider({ agent = "econic", children }: { agent?: string; children: ReactNode }) {
  const style = useFaceStyle();
  const render = useCallback<RenderAgentFace>(
    (w) => (style === "icon" ? null : <LazyAgentFace agent={w.agentKey ?? agent} size={w.size} state={w.state} />),
    [style, agent],
  );
  return <AgentFaceContext.Provider value={render}>{children}</AgentFaceContext.Provider>;
}
